import { render, staticRenderFns } from "./LinkedLotNo.vue?vue&type=template&id=5398885d&scoped=true"
import script from "./LinkedLotNo.vue?vue&type=script&lang=js"
export * from "./LinkedLotNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5398885d",
  null
  
)

export default component.exports